import { Component, HostListener, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { TimeScanningService } from "./shared/data.service";
import { ScanPointTimeScanRequest } from "./shared/ScanPointTimeScanRequest";

@Component({
	selector: "app-time-scanning",
	templateUrl: "./time-scanning.component.html",
	styleUrls: ["./time-scanning.component.css"],
})
export class TimeScanningComponent implements OnInit {
	constructor(private spService: TimeScanningService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadScanPointPreferences();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	Init: boolean = false;
	loading: boolean = true;
	Processing: boolean = false;

	// Preferences
	// ScanStationID: number = -1;
	FacilityID: number = -1;
	FacilityName: string = "N/A";
	FacilityLocationID: number = -1;
	FacilityLocationName: string = "N/A";
	TimeScanTypeID: number = -1;
	TimeScanTypeDesc: string = "N/A";
	IsAsyncScan: boolean = false;
	LastHallPassReasonID: number = -1;
	Receipt_IDPrinterID: number = -1;

	ViewOption: string = "All"; //All | Scanned | Manual
	NextBarcode: string = "";

	lstAllScans: any = []; //All current scans
	lstSelectedScans: any = []; //Filtered for Barcode or Manual

	lstTimeScanType: any = []; //For Settings

	ShowManual: boolean = false;
	ShowSettings: boolean = false;

	mp3Player: any = new Audio();

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	loadScanPointPreferences() {
		this.loading = true;

		var result = this.spService.ScanPointSelectPreferences();
		result.subscribe(
			(response) => {
				var Data: any = response;

				this.FacilityID = Data.FacilityID;
				this.FacilityName = Data.FacilityName;
				this.FacilityLocationID = Data.FacilityLocationID;
				this.FacilityLocationName = Data.FacilityLocationName;
				this.TimeScanTypeID = Data.TimeScanTypeID;
				this.TimeScanTypeDesc = Data.TimeScanTypeDesc;
				this.IsAsyncScan = Data.IsAsyncScan == 1 ? true : false;
				this.LastHallPassReasonID = Data.LastHallPassReasonID;
				this.Receipt_IDPrinterID = Data.Receipt_IDPrinterID;

				this.lstTimeScanType = Data.lstTimeScanType;

				this.loading = false;
				this.Init = true;
			},
			(error) => {
				this.loading = false;
				this.Init = true;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	onClear() {
		this.NextBarcode = "";
		if (this.lstAllScans.length > 0) {
			this.confirmationService.confirm({
				key: "parent",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: "Are you sure you want to clear all scanned items?",
				header: "Clear Scans",
				icon: "fa",
				accept: () => {
					this.FinishClear();
				},
			});
		}
	}

	FinishClear() {
		this.lstAllScans = [];
		this.lstSelectedScans = [];
	}

	onManual() {
		this.NextBarcode = "";
		this.ShowSettings = false;
		this.ShowManual = !this.ShowManual;
	}

	onSettings() {
		this.NextBarcode = "";
		this.ShowManual = false;
		this.ShowSettings = !this.ShowSettings;
	}

	onUpdateType(TimeScanType: any) {
		this.TimeScanTypeID = TimeScanType.TimeScanTypeID;
		this.TimeScanTypeDesc = TimeScanType.TimeScanTypeDesc;
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////

	onViewOptionChange(val) {
		this.ViewOption = val;

		this.lstSelectedScans = [];

		for (var z = 0; z < this.lstAllScans.length; z++) {
			var next = this.lstAllScans[z];

			if (this.ViewOption == "All") {
				this.lstSelectedScans = [...this.lstSelectedScans, next];
			} else if (this.ViewOption == "Scanned" && next.IsManual == false) {
				this.lstSelectedScans = [...this.lstSelectedScans, next];
			} else if (this.ViewOption == "Manual" && next.IsManual == true) {
				this.lstSelectedScans = [...this.lstSelectedScans, next];
			}
		}
	}

	@HostListener("window:keydown", ["$event"])
	LogKeys(event: KeyboardEvent) {
		if (this.ShowManual == false && this.ShowSettings == false && this.IsLoading() == false) {
			if (event.key == "Enter") {
				this.ProcessScan(String(this.ReplaceAll(this.NextBarcode.toLowerCase(), "shift", "")));
				this.NextBarcode = "";
			} else if (event.key.length == 1) {
				this.NextBarcode += event.key;
			}
		}
	}

	ReplaceAll(OriginalString: string, ToFind: string, ReplaceWith: string) {
		// Go through all instances
		while (OriginalString.indexOf(ToFind) != -1) {
			OriginalString = OriginalString.replace(ToFind, ReplaceWith);
		}

		return OriginalString;
	}

	ProcessScan(Barcode: string) {
		this.Processing = true;

		var parms: ScanPointTimeScanRequest = {
			Barcode: Barcode,
			FacilityID: this.FacilityID,
			FacilityLocationID: this.FacilityLocationID,
			TimeScanTypeID: this.TimeScanTypeID,
			Receipt_IDPrinterID: this.Receipt_IDPrinterID,
			IsManual: 0,
			Scan_PersonID: -1,
			Override: 0,
			IDStatusID: -1,
			ManualComment: "",
			ReprintCardInd: -1,
			PrintedTempInd: -1,
			ChargeReprintFeeInd: -1,
			ChargeTempFeeInd: -1,
			PaidAmount: "",
			ReprintFee: "",
			TempIDFee: "",
		};

		var result = this.spService.ScanPointTimeScanInsert(parms);
		result.subscribe(
			(response: any) => {
				var Data = response;
				Data.IsManual = false;

				this.lstAllScans = [...this.lstAllScans, response];

				if (this.ViewOption != "Manual") {
					this.lstSelectedScans = [...this.lstSelectedScans, response];
				}

				this.LoadScanSound(response);

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onManualScan(parms) {
		this.Processing = true;

		var result = this.spService.ScanPointTimeScanInsert(parms);
		result.subscribe(
			(response: any) => {
				var Data = response;
				Data.IsManual = true;

				this.lstAllScans = [...this.lstAllScans, response];

				if (this.ViewOption != "Scanned") {
					this.lstSelectedScans = [...this.lstSelectedScans, response];
				}

				this.LoadScanSound(response);

				this.ShowManual = false;

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	LoadScanSound(LastScan) {
		var SoundLibraryID: number = -1;

		if (LastScan.lstAlerts.length > 0) {
			SoundLibraryID = LastScan.lstAlerts[0].SoundLibraryID;
		}
		// No Alerts, Check if reminders have sounds
		else {
			if (LastScan.lstReminders.length > 0) {
				SoundLibraryID = LastScan.lstReminders[0].SoundLibraryID;
			}
		}

		var SuccessScan = false;

		//
		// No List of alerts, but scan failed, or student doesn't belong in facility
		//
		if (LastScan.Success == false || (LastScan.Override == false && LastScan.BelongsInFacility == false)) {
			SuccessScan = false;
		} else {
			SuccessScan = true;
		}

		var result = this.spService.ScanPointGetScanSound(this.FacilityID, SoundLibraryID, SuccessScan == true ? 1 : 0);
		result.subscribe(
			(response: any) => {
				this.mp3Player.pause(); // First, Try to stop any playing files
				this.mp3Player = new Audio(response.SoundData);
				this.mp3Player.play();
			},
			(error) => {}
		);

		// ScanPointGetScanSound(FacilityID, SoundLibraryID)
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////
}
